import { useTranslation } from 'react-i18next'

import { AcknowledgeModal, Modal, type ModalProps } from '@percent/lemonade'

type UnexpectedErrorModalProps = {
  message: string
  description?: string
  onClose: VoidFunction
  closeBtnCopy?: string
} & Pick<ModalProps, 'open'>

export function UnexpectedErrorModal({ open, onClose, message, description, closeBtnCopy }: UnexpectedErrorModalProps) {
  const { t } = useTranslation()

  return (
    <Modal borderRadiiSize="xlarge" onClose={onClose} open={open}>
      <AcknowledgeModal
        result="negative"
        title={message}
        description={description || t('workplace_giving.errors.tryAgainLater')}
        buttonText={closeBtnCopy || t('workplace_giving.common.done')}
        handleClose={onClose}
        buttonShape="oval"
      />
    </Modal>
  )
}
